
import { ArrowRight, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

export const AboutSection = () => {
  return (
    <section className="py-16 md:py-24 bg-dental-cream">
      <div className="container-custom">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="relative">
            <div className="relative">
              <div className="w-full h-full absolute -top-6 -left-6 rounded-2xl border-2 border-dental-highlight/20"></div>
              <img src="/lovable-uploads/ca888950-cd21-4651-af91-c5ad93a14833.png" alt="Asrani Dental Clinic Reception - Shaping smiles since 1986" className="w-full h-auto rounded-2xl shadow-soft animate-fade-in" loading="lazy" width="600" height="400" />
              <div className="absolute -bottom-8 -right-8 bg-dental-highlight text-white p-6 rounded-xl shadow-soft flex items-center animate-fade-in-up">
                <div className="mr-4">
                  <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21 7L9 19L3.5 13.5L4.91 12.09L9 16.17L19.59 5.59L21 7Z" fill="currentColor" />
                  </svg>
                </div>
                <div>
                  <p className="font-serif font-medium">Trusted by</p>
                  <div>
                    <p className="text-2xl font-serif font-bold">100,000+ Patients</p>
                    <p className="text-lg font-serif">25,000+ Families</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="animate-fade-in-up">
            <span className="inline-block text-dental-highlight font-medium mb-4 uppercase tracking-wider text-sm">
              About Our Clinic
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-semibold mb-6 leading-tight">
              Exceptional Dental Care in Nagpur <span className="text-dental-highlight">Since 1986</span>
            </h2>
            <p className="text-dental-muted mb-6">
              At Asrani Dental Clinic, we're committed to providing comprehensive dental care in a comfortable, state-of-the-art environment. Our team combines years of experience with the latest technology to deliver treatments that are effective, efficient, and tailored to your unique needs.
            </p>
            <p className="text-dental-muted mb-8">
              We believe that a healthy smile is essential to overall wellness, and we're dedicated to helping you achieve and maintain optimal oral health through personalized care and education.
            </p>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
              <div className="flex items-start">
                <div className="mr-3 text-dental-highlight">
                  <ChevronRight size={20} />
                </div>
                <div>
                  <h4 className="font-medium mb-1">State-of-the-Art Facility</h4>
                  <p className="text-sm text-dental-muted">Modern equipment for precise diagnostics and treatment</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="mr-3 text-dental-highlight">
                  <ChevronRight size={20} />
                </div>
                <div>
                  <h4 className="font-medium mb-1">Qualified Specialists</h4>
                  <p className="text-sm text-dental-muted">Experienced dentists across all specialties</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="mr-3 text-dental-highlight">
                  <ChevronRight size={20} />
                </div>
                <div>
                  <h4 className="font-medium mb-1">Comfortable Environment</h4>
                  <p className="text-sm text-dental-muted">Relaxing atmosphere designed for your comfort</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="mr-3 text-dental-highlight">
                  <ChevronRight size={20} />
                </div>
                <div>
                  <h4 className="font-medium mb-1">Affordable Care</h4>
                  <p className="text-sm text-dental-muted">Flexible payment options and insurance plans</p>
                </div>
              </div>
            </div>
            
            <Button className="btn-primary flex items-center text-base group" asChild>
              <Link to="/about">
                Learn More About Us
                <ArrowRight size={18} className="ml-2 transition-transform duration-300 group-hover:translate-x-1" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
